import TelehealthContextProvider from '@/context/TelehealthContext';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

const BaseTelehealth = () => {
  useEffect(() => {
    document.title = 'Telehealth Web';
    return () => {
      document.title = 'Claims';
    };
  }, []);

  return (
    <TelehealthContextProvider>
      <Outlet />
    </TelehealthContextProvider>
  );
};

export default BaseTelehealth;
